import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { SummaryBuilder } from '../../models/builders/summary.builder';
import { EventTypeBuilder } from '../../models/builders/event-type.builder';
import { getServerDateDiff } from '../../utils/response.utils';
import { valueOf } from '../../utils/string.utils';
import { BY_PART } from '../../config/modularized.config';

@Injectable()
export class SummaryApiService {
  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = `${environment.apiUrl}summaries`;
  }

  getSummaries(models: any) {
    let params = new HttpParams();
    if (models && environment.summaryModularized === BY_PART) {
      for (const model of models) {
        params = params.append('models', model.hash);
      }
    }
    return this.httpClient.get(`${this.apiUrl}`, { observe: 'response', params: params }).pipe(
      map(resp => SummaryBuilder.modelSummariesFromList(resp.body, getServerDateDiff(resp)))
    );
  }

  getEventTypes() {
    return this.httpClient.get(`${this.apiUrl}/event-types`)
      .pipe(
        map(EventTypeBuilder.fromList)
      );
  }

  getModelOees(model: string, start: number, end: number) {
    const params = new HttpParams()
      .append('model', model)
      .append('start', valueOf(start))
      .append('end', valueOf(end));

    return this.httpClient.get(`${this.apiUrl}/oees`, { params })
      .pipe(map(SummaryBuilder.modelSummaryOeeFromList));
  }

  getModelTimes(model: string, start: number, end: number) {
    const params = new HttpParams()
      .append('model', model)
      .append('start', valueOf(start))
      .append('end', valueOf(end));

    return this.httpClient.get(`${this.apiUrl}/times`, { params })
      .pipe(map(SummaryBuilder.modelTimesFromList));
  }

  getModelTimelines(model: string, start: number, end: number) {
    const params = new HttpParams()
      .append('model', model)
      .append('start', valueOf(start))
      .append('end', valueOf(end));

    return this.httpClient.get(`${this.apiUrl}/timelines`, { params })
      .pipe(map(SummaryBuilder.modelTimelinesFromList));
  }

  getModelEvents(model: string, start: number, end: number, count: number, type?: number, lastEvent?: string) {
    const params = new HttpParams()
      .append('model', model)
      .append('start', valueOf(start))
      .append('end', valueOf(end))
      .append('count', valueOf(count))
      .append('activity', valueOf(type))
      .append('lastEvent', lastEvent);

    return this.httpClient.get(`${this.apiUrl}/events`, { params })
      .pipe(map(SummaryBuilder.modelSummaryEventsFromList));
  }

  getModelTimelineDetail(model: string, eventTime: number, start: number, end: number) {
    const params = new HttpParams()
      .append('model', model)
      .append('eventTime', valueOf(eventTime))
      .append('start', valueOf(start))
      .append('end', valueOf(end));

    return this.httpClient.get(`${this.apiUrl}/timeline-detail`, { params })
      .pipe(map(SummaryBuilder.modelTimelineDetailFromJson));
  }

  getModelCurrentTask(model: string) {
    const params = new HttpParams()
      .append('model', model);

    return this.httpClient.get(`${this.apiUrl}/current-task`, { params })
      .pipe(map(SummaryBuilder.modelCurrentTaskFromJson));
  }

  getModelCurrentTaskProgramDetail(program: string) {
    const params = new HttpParams()
      .append('program', program);

    return this.httpClient.get(`${this.apiUrl}/current-task-detail`, { params })
      .pipe(map(SummaryBuilder.modelCurrentTaskProgramDetailFromJson));
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/summary-api.service.ts